import { applyMiddleware, compose, createStore } from 'redux';
import { fromJS } from 'immutable';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import sagas from './sagas';
import { localStoragePull, localStoragePush } from 'helpers/localstorage-sync';
// import * as Sentry from '@sentry/browser'

const sagaMiddleware = createSagaMiddleware(/*{
  onError: error => {
    Sentry.captureException(error)
  }
}*/);
let runningSagas = [];

let _store = null;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState = {}) {
  if (_store) {
    return _store;
  }

  // Get items from storage and merge in initial state
  const localStorageState = localStoragePull();
  const immutableState = fromJS(initialState).merge(localStorageState);

  _store = createStore(reducers, immutableState, composeEnhancers(applyMiddleware(sagaMiddleware)));

  // Create hook for async sagas
  const startSagas = sagas => {
    runningSagas.forEach(task => task.cancel());
    runningSagas = sagas.map(saga => sagaMiddleware.run(saga));
  };
  startSagas(sagas);

  // Push to localstorage
  localStoragePush(_store);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      _store.replaceReducer(nextRootReducer);
    });
    module.hot.accept('./sagas', () => {
      const nextSagas = require('./sagas').default;
      startSagas(nextSagas);
    });
  }

  return _store;
}



// WEBPACK FOOTER //
// ./app/redux/create.js